import React from 'react';
import { useParams } from 'react-router-dom';
import { getServiceCounty } from '../data/counties';
import { getServiceCity } from '../data/cityMaterialContent';
import { County } from './County';
import { City } from './City';
import { NotFound } from './NotFound';

/**
 * One-segment /gravel-delivery/:locationSlug route.
 *
 * Counties and cities share this path shape, so this picks the right page for
 * the slug. Anything that is neither renders the 404 page (which carries a
 * noindex tag) rather than a thin, indexable near-duplicate.
 */
export function LocationLanding() {
  const {
    locationSlug = ''
  } = useParams<{
    locationSlug: string;
  }>();
  if (getServiceCounty(locationSlug)) return <County data-id="element-3675" data-mp="35xhosv6g47ro" />;
  if (getServiceCity(locationSlug)) return <City data-id="element-3676" data-mp="35ystcx7ptjju" />;
  return <NotFound data-id="element-3677" data-mp="193wamwtdzfy8" />;
}